<template>
  <div class="component-periods">
    <label v-for="period of periods" :key="period" class="checkbox">
      <input type="checkbox" name="period"  v-model="selected" :value="period">
      {{ period }}
    </label>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Periods, periodType } from '@/store/common.types'

@Component
export default class PeriodsInput extends Vue {
  @Prop() value!: periodType[]

  private periods = Periods

  private get selected(): periodType[] {
    return this.value
  }

  private set selected(periods: periodType[]) {
    this.$emit('input', periods)
  }
}
</script>

<style scoped>
input[type="checkbox"] {
  margin-right:8px;
}

.component-periods {
  display:flex;
  flex-wrap: wrap;
}

.checkbox {
  display: block;
  width: 65px;
}
</style>
